import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getUsersData,
  uploadUserImage,
} from "@services/API/Requests/UserRequests";
import { error_message } from "@constants/Errors";
import messages from "@constants/Messages";

export const UseUserPhotoUploadPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [fileMap, setFileMap] = useState<{ [key: number]: File[] }>({});

  const [succesfulUploads, setSuccessfulUploads] = useState<number>(0);
  const [failedUploads, setFailedUploads] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(false);
  const [doingUpload, setDoingUpload] = useState<boolean>(false);

  const [error, setError] = useState<string | null>(null);
  const [userData, setUserData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalUsers, setTotalUsers] = useState<number>(0);

  const [itemsPerPage, setItemsPerPage] = useState<number>(5);

  const totalPages: number = Math.ceil(totalUsers / itemsPerPage);

  const uploadImageDataToast = () =>
    toast.success(messages.image.upload_success);

  const uploadImageDataFailToast = () =>
    toast.error(error_message.image.upload);

  const handleUpload = () => {
    setDoingUpload(true);
    let successCount = 0;
    let failureCount = 0;

    const uploadPromises = selectedUsers.map((userId) => {
      if (fileMap[userId]) {
        return uploadUserImage(userId, fileMap[userId])
          .then((response) => {
            if (response.status < 300) {
              successCount++;
            } else {
              failureCount++;
            }
          })
          .catch((error) => {
            console.error(error_message.image.upload, error);
          });
      }
      return Promise.resolve();
    });

    Promise.all(uploadPromises)
      .then(() => {
        setSuccessfulUploads(successCount);
        setFailedUploads(failureCount);
        setDoingUpload(false);
        handlePostToastNotification(successCount, failureCount);
      })
      .catch(() => {
        console.error(error_message.image.upload);
        setFailedUploads(failedUploads);
        setSuccessfulUploads(succesfulUploads);
        setDoingUpload(false);
        uploadImageDataFailToast();
        handlePostToastNotification(successCount, failureCount);
      });
  };

  const handlePostToastNotification = (successCount, failureCount) => {
    if (successCount > 0) {
      uploadImageDataToast();
    }
    if (failureCount > 0) {
      uploadImageDataFailToast();
    }
    setSuccessfulUploads(0);
    setFailedUploads(0);

    setTimeout(() => {
      navigate("/users");
    }, 2000);
  };

  const onCancel = () => {
    navigate("/users");
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    fetchUserInformation();
  }, []);

  const fetchUserInformation = async ({
    curPage = currentPage,
    itemPerPage = itemsPerPage,
    query = "",
  } = {}) => {
    await getUsersData(
      setUserData,
      setTotalUsers,
      setError,
      setLoading,
      curPage,
      itemPerPage,
      query,
    );
  };

  const handlePageChange = async (newPage: number) => {
    fetchUserInformation({ curPage: newPage });
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const updateUserData = async () => {
      fetchUserInformation({ curPage: 1 });
      setCurrentPage(1);
    };

    updateUserData();
  }, [itemsPerPage]);

  return {
    doingUpload,
    loading,
    selectedUsers,
    userData,
    currentPage,
    totalPages,
    totalUsers,
    itemsPerPage,
    fileMap,
    setSelectedUsers,
    setFileMap,
    handlePageChange,
    setItemsPerPage,
    onCancel,
    handleUpload,
  };
};
